(() => {
  if (window.LuminovaHeroRecommendations) return;

  class HeroRecommendations {
    constructor(root) {
      if (root.dataset.lnRecommendationsReady === 'true') return;
      root.dataset.lnRecommendationsReady = 'true';
      this.root = root;
      this.track = root.querySelector('[data-ln-rec-track]');
      this.cards = Array.from(root.querySelectorAll('[data-ln-rec-card]'));
      this.index = 0;
      this.abortController = new AbortController();
      this.bind();
    }

    bind() {
      const options = { signal: this.abortController.signal };
      this.root.addEventListener('click', (event) => this.onClick(event), options);
      this.root.addEventListener('submit', (event) => this.onSubmit(event), options);
      this.track?.addEventListener('scroll', () => this.syncIndex(), { ...options, passive: true });
    }

    onClick(event) {
      const variant = event.target.closest?.('[data-ln-rec-variant]');
      if (variant && this.root.contains(variant)) {
        this.selectVariant(variant);
        return;
      }
      if (event.target.closest?.('[data-ln-rec-previous]')) {
        this.move(-1);
        return;
      }
      if (event.target.closest?.('[data-ln-rec-next]')) this.move(1);
    }

    onSubmit(event) {
      const form = event.target.closest?.('[data-ln-rec-form]');
      if (!form || !this.root.contains(form)) return;
      event.preventDefault();
      this.addToCart(form);
    }

    selectVariant(control) {
      const card = control.closest('[data-ln-rec-card]');
      if (!card) return;
      card.querySelectorAll('[data-ln-rec-variant]').forEach((variant) => {
        const active = variant === control;
        variant.classList.toggle('is-active', active);
        variant.setAttribute('aria-pressed', String(active));
      });
      const input = card.querySelector('[data-ln-rec-variant-input]');
      const price = card.querySelector('[data-ln-rec-price]');
      const image = card.querySelector('.ln-hero-recommendations__image');
      const button = card.querySelector('[data-ln-rec-atc]');
      const available = control.dataset.variantAvailable === 'true';
      if (input) input.value = control.dataset.variantId || '';
      if (price) price.textContent = control.dataset.variantPrice || '';
      if (image && control.dataset.imageSrc) {
        image.src = control.dataset.imageSrc;
        if (control.dataset.imageSrcset) image.srcset = control.dataset.imageSrcset;
      }
      if (button) {
        button.disabled = !available;
        button.textContent = available ? button.dataset.addLabel : button.dataset.soldOutLabel;
      }
    }

    move(direction) {
      if (!this.track || this.cards.length < 2) return;
      this.index = (this.index + direction + this.cards.length) % this.cards.length;
      this.track.scrollTo({ left: this.cards[this.index].offsetLeft, behavior: 'smooth' });
    }

    syncIndex() {
      if (!this.track || !this.cards.length) return;
      const left = this.track.scrollLeft;
      this.index = this.cards.reduce((closest, card, index) => {
        const currentDistance = Math.abs(this.cards[closest].offsetLeft - left);
        const nextDistance = Math.abs(card.offsetLeft - left);
        return nextDistance < currentDistance ? index : closest;
      }, 0);
    }

    async addToCart(form) {
      const input = form.querySelector('[data-ln-rec-variant-input]');
      const button = form.querySelector('[data-ln-rec-atc]');
      const status = form.querySelector('[data-ln-rec-status]');
      const variantId = Number(input?.value);
      if (!variantId || button?.disabled) return;
      const addLabel = button.dataset.addLabel || 'Add to cart';
      button.disabled = true;
      button.textContent = 'Adding…';
      if (status) status.textContent = '';
      try {
        const cartUI = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sections = [...new Set((cartUI?.getSectionsToRender?.() || []).map((section) => section.id))].slice(0, 5);
        const rootUrl = window.Shopify?.routes?.root || '/';
        const response = await fetch(window.routes?.cart_add_url || `${rootUrl}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            ...(sections.length ? { sections: sections.join(','), sections_url: window.location.pathname } : {})
          })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not add this product.');
        if (typeof cartUI?.renderContents === 'function' && data.sections) {
          cartUI.classList.remove('is-empty');
          cartUI.setActiveElement?.(button);
          cartUI.renderContents({ ...data, ...(data.items?.[0] || {}), sections: data.sections });
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
        button.textContent = 'Added';
        if (status) status.textContent = 'Added to cart';
      } catch (error) {
        button.textContent = addLabel;
        if (status) status.textContent = error.message || 'Could not add this product.';
      } finally {
        window.setTimeout(() => {
          const selected = form.closest('[data-ln-rec-card]')?.querySelector('[data-ln-rec-variant][aria-pressed="true"]');
          const available = selected ? selected.dataset.variantAvailable === 'true' : true;
          button.disabled = !available;
          button.textContent = available ? addLabel : button.dataset.soldOutLabel;
        }, 1200);
      }
    }
  }

  const initialize = (scope = document) => {
    scope.querySelectorAll?.('[data-ln-hero-recommendations]').forEach((root) => new HeroRecommendations(root));
  };

  window.LuminovaHeroRecommendations = { initialize };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
